import { useRoutineFilter, useSetRoutineFilter } from '@gripp/shared-logic';
import {
  countFilters,
  FilterHeaders,
  RoutineSearchInput,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { RoutinesToolbar } from './routinesToolbar';

export const RoutinesFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();

  const { data: routineFilter } = useRoutineFilter();
  const { mutateAsync: setRoutineFilter } = useSetRoutineFilter();
  const filterCount = countFilters(routineFilter);

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/new-routines/filters');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={routineFilter?.keyword}
        searchComponent={<RoutineSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() => setRoutineFilter({ keyword: '' })}
        filterCount={filterCount}
        Routes={{}}
      />
      <RoutinesToolbar />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
  },
});
